/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
export class LoadMapConfig {
    static readonly type = '[MapConfig] Load config';

    constructor(public mapName: string) {}
}

export class MapConfigLoaded {
    static readonly type = '[MapConfig] Load config success';
}

export class ResetMapConfigState {
    static readonly type = '[MapConfig] Reset to default state';
}

export class ReloadLayers {
    static readonly type = '[MapConfig] Reload layers from server';
}

export class LayerStateChange {
    static readonly type = '[ActiveMapState] Layer state change';
}

export class SetGroupVisibility {
    static readonly type = '[Legend] Set group visibility';

    constructor(
        public groupName: string,
        public visible: boolean,
    ) {}
}

export class SetLayerVisibility {
    static readonly type = '[Legend] Set layer visibility';

    constructor(
        public layerNames: string|string[],
        public visible: boolean,
        public force: boolean = false,
    ) {}
}

export class SetNodeExpandedState {
    static readonly type = '[Legend] Set node expanded state';

    constructor(
        public name: string,
        public isGroup: boolean,
        public expanded: boolean
    ) {}
}

export class PersistUserMapConfigState {
    static readonly type = '[MapConfig] Persist User Map Config State';
}

export class ResetUserMapConfigState {
    static readonly type = '[MapConfig] Reset User Map Config State to default';
}

